/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface IRealityCheck {
        assessmentName: string;
        assessmentId
        assessment: IAssessment;
        sessions: IAssessmentSession[];
    }

    class State {
        step: number;
        sessionId?: number;
        page?: number;
    }

    class RealityCheck implements IRealityCheck {
        static controllerId: string = "realityCheck";
        static $inject: string[] = ["$scope", "common", "Restangular", "$q", "$location", "config"];

        assessmentName: string = "Reality-Check"
        assessmentId: number = 10;
        currentSession: IAssessmentSession;
        assessment: IAssessment;
        sessions: IAssessmentSession[];
        loading: boolean = true;
        ncCareersUrl: string;

        cacheBuster = Date.now() + '' + Math.random().toString(36).substring(10);

        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;

        constructor(private $scope: ng.IScope, private common: ICommonFactory, private Restangular: Restangular.IService, private $q: ng.IQService,
            private $location: ng.ILocationService, private config: Config) {

            this.log = common.logger.getLogFn(RealityCheck.controllerId);
            this.logError = common.logger.getLogFn(RealityCheck.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(RealityCheck.controllerId, "success");
            this.ncCareersUrl = config.ncCareersUrl;

            this.common.authentication.authenticate(true).then(() => {
                this.activate();
            });
        }


        activate() {
            var promises: ng.IPromise<any>[] = [this.getAssessment()];

            this.common.activateController(promises, RealityCheck.controllerId)
                .then(() => {

                    if (this.sessions == null) {
                        promises.push(this.getSessions());
                    }

                    this.loading = false;
                });
        }

        getAssessment(): ng.IPromise<void> {
            return this.Restangular.one("assessments", this.assessmentId).get<IAssessment>()
                .then((result: IAssessment) => {
                    this.assessment = result
                },
                    (reason) => {
                        this.logError(reason.message, reason, true)
                    });
        }

        getSessions(): ng.IPromise<void> {
            return this.Restangular.one("assessments", this.assessmentId).one("sessions").get<IAssessmentSession[]>()
                .then((sessions: IAssessmentSession[]) => {
                    this.sessions = sessions;
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }
    }

    angular.module("app").controller(RealityCheck.controllerId, RealityCheck);
}